import { createContext } from 'react';

export interface FeatureFlags {
  careerSiteSettings: boolean;
  careerSiteInterdependentFilters: boolean;
  careerSitePrivacyPolicy: boolean;
}

export type FeatureFlagContextData = {
  featureFlags: FeatureFlags;
  setFlags: (flags: FeatureFlags) => void;
};

export const defaultFeatureFlagContext: FeatureFlagContextData = {
  featureFlags: {
    careerSiteSettings: false,
    careerSiteInterdependentFilters: false,
    careerSitePrivacyPolicy: false,
  },
  setFlags: () => undefined,
};

export const FeatureFlagContext = createContext<FeatureFlagContextData>(
  defaultFeatureFlagContext,
);
